<template>
<div id="layout_p020" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Layout P020" class="elevation-1 px-5 py-3" >
                                        
                        <div class="contenedor-tab-reportes" >
                            <v-card-text>
                            <v-card-title>
                                <span class="headline" ></span>
                            </v-card-title>
                            
                            </v-card-text>
                            
                            <v-card-text>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4" >
                                        1.- Descargar Layout e ingresar información:
                                    </v-col>
                                    <v-col sm="1" md="1" lg="1" >
                                        <exportar-excel :data="camposLayout" :exportFields="encabezadoLayout" name="Layout P020.xlsx" >
                                        <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                            <v-icon dark>receipt</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4" >
                                        2.- Cargar el layout:
                                    </v-col>
                                    <v-col sm="1" md="1" lg="1" >
                                        <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                                    </v-col>
                                </v-row>
                            </v-card-text>   
                                    
                                                        
                        
                        <v-card-text>
                            <v-card-title>
                                <span class="headline" ></span>
                                <span class="subheading" >                          
                                </span>
                            </v-card-title>                  
                                <v-container grid-list-md text-xs-center>
                                <v-client-table :data="referencias" :columns="columnsReferencias" :options="optionsReferencias" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>                              
                                </v-client-table>
                                </v-container>                                
                            
                            </v-card-text>                                
                        </div>
                        
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    components: {        
    },

    data: () => ({
        representantesArray: [],
        emisoresArray: [],
        referencias: [],
        menu1: false,
        name: "datagrid",
        importData: [],
        show_loading: true,
        columnsReferencias: [
            "referencia",            
        ],        
        optionsReferencias: {
            filterable: ["referencia"],
            sortable: ["referencia"],
            headings: {
                referencia: "Referencia",                
            },
            headings: {
                referencia: "Planta/Referencia",                
            },
              
        },
        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Ecosting",
                disabled: true,
                to: ""
            },
            {
                text: "Layout P020",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "nombre"
        },
        search: "",
        model: {
            id_representante_legal: 0,
            nombre: "",
            apellido_paterno: "",
            apellido_materno: "",
            rfc: "",
            escritura_publica: "",
            volumen: "",
            ciudad: "",
            fecha: "",
            numero_notario: "",
            nombre_notario: "",            
            estado: "",
            cliente: 0,
            metadato: "N/A"
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            rfclen: v =>
                (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres"
        },
        representantes: [],
        emisores:[],
        
        selected: [],
        camposexcel: {
            Pedimento: "pedimento",
            "Año": "anio",
            "Referencia": "referencia",                
        },
        
        //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
        encabezadoLayout: {
            pedimento:"pedimento",	
            anio_pedimento:"anio_pedimento",
            tax_id:"tax_id",	
            fecha:"fecha",
            numero:"numero",	
            secuencia:"secuencia",
            concepto:"concepto",
            descripcion:"descripcion",
            cantidad:"cantidad",
            um:"um",
            valor_unitario:"valor_unitario",
            subtotal:"subtotal",
            total_facturado:"total_facturado",	
            clave_moneda:"clave_moneda",
            rfc_representante:"rfc_representante"
        },
        //van vacíos para solo descargar layout con encabezados
        camposLayout: [{
            pedimento:"[Número de Pedimento]",	
            anio_pedimento:"[Año de pedimento]",
            tax_id:"[RFC o Tax ID del emisor]",	
            fecha:"[Fecha de Expedición en formato AAAA-MM-DD]",
            numero:"[Número de Factura]",	
            secuencia:"[Número de Partida secuencia de Factura]",
            concepto:"[Seguros | Fletes | Maniobras | Otros]",
            descripcion:"[Descripción del incrementable]",
            cantidad:"[Cantidad]",
            um:"[Unidad de Medida]",
            valor_unitario:"[Valor en USD o MXN]",
            subtotal:"[Valor en USD o MXN]",
            total_facturado:"[Valor en USD o MXN]",	
            clave_moneda:"[Clave USD o MXN]",
            rfc_representante:"[RFC del Representante Legal - Opcional]"
        }],
        
        camposObligatorios: [
            "pedimento",
            "anio_pedimento",
            "tax_id",	
            "fecha",
            "numero",	
            "secuencia",
            "concepto",
            "descripcion",
            "cantidad",
            "um",
            "valor_unitario",
            "subtotal",
            "total_facturado",	
            "clave_moneda",
        ],
        estados: [],
        paises: [],
    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.representantes;
            }

        },
    },
    methods: {
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Representante Legal";
                this.update = false;
            } else {
                this.title = "Actualizar Representante Legal";
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.cliente = this.$local_storage.get("id_cliente");
        },

        
        cargarRepresentantes: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                cliente: this.$local_storage.get("id_cliente")
            };
            axios
                .post(this.URL + "representantes/get_representantes/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.representantes = res.data;
                        this.representantesArray = this.representantes.map((rep) => rep.rfc);                        
                    }
                })
                .catch(err => {                   
                    console.log(err);                    
                });
                axios.post(this.URL + "emisores_destinatarios/get_emisores/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.emisores = res.data;
                        this.emisoresArray = this.emisores.map((rep) => rep.rfc);
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {                                       
                    this.$root.$dialogLoader.hide();
                });
        },

            
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        validarPatronPedimento(pedimento){
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },
        validaRepresentante(rfc_repre){
            return this.representantesArray.includes(rfc_repre);
        },
        validaEmisor(rfc_emisor){
            return this.emisoresArray.includes(rfc_emisor);
        },
        validaEntero(numero){
            const pattern = /^[\d]*$/;
            return pattern.test(numero);
        },
       
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },
                
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            const decimalPatron = /^[\d]*(\.{0,1}[\d]*)$/;            


            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else if (results.length > 500){
                    errores++;
                    erroresText += "El máximo de filas a procesar es 500, favor de verificar.";
                } else {
                    for (var k in results) {                        
                        results[k]["rfc"] = this.$local_storage.get("rfc");

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {

                            if(!this.validarPatronPedimento(results[k]['pedimento'])){
                                errores++;
                                errorTmp = '<br/>' + "- El pedimento '" + results[k]['pedimento'] + "' no es un pedimento válido. Ej. 240-1234-9000123";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(!this.validaEntero(results[k]['anio_pedimento'])){
                                errores++;
                                errorTmp = '<br/>' + "- El anio_pedimento '" + results[k]['anio_pedimento'] + "' no es un número entero válido.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            let fechaOrig = results[k]["fecha"];
                            results[k]["fecha"] = thisObject.parseDateExcel(fechaOrig);
                            if (results[k]["fecha"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La fecha '" + fechaOrig + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            
                            if(!this.validaEntero(results[k]['secuencia'])){
                                errores++;
                                errorTmp = '<br/>' + "- La secuencia '" + results[k]['secuencia'] + "' no es un número entero válido.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(results[k]['cantidad']!= undefined){                                
                                if (!decimalPatron.test(results[k]['cantidad']) ){
                                    errores++;
                                    errorTmp = '<br/>' + "- La cantidad '" + results[k]['cantidad'] + "' no es una cantidad válida.";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;
                                }
                            }

                            if(results[k]['valor_unitario']!= undefined){                                
                                if (!decimalPatron.test(results[k]['valor_unitario']) ){
                                    errores++;
                                    errorTmp = '<br/>' + "- El valor_unitario '" + results[k]['valor_unitario'] + "' no es una cantidad válida.";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;
                                }
                            }

                            if(results[k]['subtotal']!= undefined){                                
                                if (!decimalPatron.test(results[k]['subtotal']) ){
                                    errores++;
                                    errorTmp = '<br/>' + "- El subtotal '" + results[k]['subtotal'] + "' no es una cantidad válida.";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;
                                }
                            }

                            if(results[k]['total_facturado']!= undefined){                                
                                if (!decimalPatron.test(results[k]['total_facturado']) ){
                                    errores++;
                                    errorTmp = '<br/>' + "- El total_facturado '" + results[k]['total_facturado'] + "' no es una cantidad válida.";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;
                                }
                            }

                            if(results[k]['clave_moneda']!= undefined){   
                                results[k]['clave_moneda'] = results[k]['clave_moneda'].toString().toUpperCase().trim();                             
                                if (results[k]['clave_moneda']!="USD" && results[k]['clave_moneda']!="MXN" ){
                                    errores++;
                                    errorTmp = '<br/>' + "- clave_moneda '" + results[k]['clave_moneda'] + "' debe ser USD o MXN";
                                    if (erroresText.indexOf(errorTmp) == -1)
                                        erroresText += errorTmp;
                                }
                            }
                            
                            if(results[k]['tax_id']!= undefined){
                                results[k]['tax_id'] = results[k]['tax_id'].toString().toUpperCase().trim();
                                if (results[k]['tax_id']!="")
                                    if(!this.validaEmisor(results[k]['tax_id'])){
                                        errores++;
                                        errorTmp = '<br/>' + "- El tax_id '" + results[k]['tax_id'] + "' no se encuentra en el catálogo de Emisores/Destinatarios.";
                                        if (erroresText.indexOf(errorTmp) == -1)
                                            erroresText += errorTmp;
                                    }
                            }

                            if(results[k]['rfc_representante']!= undefined){
                                results[k]['rfc_representante'] = results[k]['rfc_representante'].toString().toUpperCase().trim();
                                if (results[k]['rfc_representante']!="")
                                    if(!this.validaRepresentante(results[k]['rfc_representante'])){
                                        errores++;
                                        errorTmp = '<br/>' + "- El rfc_representante '" + results[k]['rfc_representante'] + "' no se encuentra en el catálogo de Representantes Legales.";
                                        if (erroresText.indexOf(errorTmp) == -1)
                                            erroresText += errorTmp;
                                    }
                            }

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    console.log(results);
                    /*this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios.post(this.$hostname + "vucem/save_referencia/", results)                    
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de comunicarse con soporte.",
                                footer: ""
                            });
                        }).then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                    */
                    
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        }
    }, //methods

    created: function () {
        this.URL = this.$hostname + "catalogos/";        
        if (this.$local_storage.get("rfc","") == ""){
            this.$swal({
                type: "info",
                title: "¡Seleccione un RFC!",
                text: "Ingrese a un rfc-cliente para poder visualizar esta vista.",
                footer: '',
            }).then(result => {
              if (result.value) {
                  this.$router.push('/home');
              }
            });
        }
        this.cargarRepresentantes();        
    }
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
.elevation-1 .v-expansion-panel >>> .v-label.theme--light {
        color: black !important;
    }    

</style>
